import React from 'react';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import { fnPostapiResponse, fnGETapiResponse, getUsername, Fnencryption } from '../APICall';

export default function CircularProgressWithLabel(props) {
   

  return (
    <div>
      <Box position="relative" display="inline-flex">
        <CircularProgress variant="determinate"
          value={props.loadpercentage} />
        <Box
          bottom={0}
          right={0}
          top={0}
          justifyContent="center"
          left={0}
          display="flex"
          alignItems="center"
          position="absolute"
        >
          {`${Math.round(props.loadpercentage)}%`}
        </Box>
      </Box>
    </div>
  );
}
